import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	edit: {
		DokladcrId: null as number | null,
		DokladPfx: null as string | null,
		DokladNr: null as number | null,
		EditDat: null as Date | null,
		EditPracId: null as number | null,
		VstupDat: null as Date | null,
		VstupPracId: null as number | null,
		DokladPfxOd: null as string | null,
		DokladNrOd: null as number | null,
		DokladPfxDo: null as string | null,
		DokladNrDo: null as number | null,
		DokladPfxUnqPrp: null as number | null,
		XDokladDruh: null as string | null,
		XDokladSk: null as string | null,
	},
	depTableNames: [],
	depTableSettings: {},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
	},
});
